import type { FC } from 'react';
import { useTheme } from 'styled-components';
import type { IIconsProps } from './types';
import { IconScale } from './types';

const Admin: FC<IIconsProps> = ({ color, size = IconScale.M }: IIconsProps) => {
  const theme = useTheme();
  if (!color) {
    color = theme.palette.primary.main;
  }
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_305_5)">
        <path
          d="M20.0094 4.55564C20.5511 4.66328 21 5.11438 21 5.66667V15.6667C20.1818 18.4167 15.2727 22.0833 12 23C8.72727 22.0833 3.81818 18.4167 3.00004 15.6667L3 5.66667C3 5.11439 3.44857 4.65674 3.98698 4.53371C6.31975 4.0007 10.1322 2.01191 11.4956 1.27605C11.8106 1.10602 12.1863 1.11121 12.4974 1.28846C13.8244 2.04472 17.5174 4.06046 20.0094 4.55564Z"
          stroke={color}
          strokeWidth="2"
        />
        <circle cx="12" cy="11" r="3" stroke={color} strokeWidth="2" />
        <path
          d="M17 18.0909C17 19.2749 17 20 17 20C17 20 14.9995 22 12 23C8.99989 22 7 20 7 20C7 20 7 20.3503 7 18.0909C7 15.8316 9.23858 14 12 14C14.7614 14 17 15.8316 17 18.0909Z"
          stroke={color}
          strokeWidth="2"
        />
      </g>
      <defs>
        <clipPath id="clip0_305_5">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Admin;
